import { Component, computed, inject } from '@angular/core';
import { UserStateService } from '../services/user-state-service';
import { Router, RouterLink } from "@angular/router";
import { environment } from "../../environments/environment";
import { NgxMaskPipe } from 'ngx-mask';

@Component({
  selector: 'app-header-component',
  imports: [
    RouterLink,
    NgxMaskPipe,
  ],
  templateUrl: './header-component.html',
  styleUrl: './header-component.css',
})
export class HeaderComponent {

  protected readonly environment = environment;

  protected readonly userStateService = inject(UserStateService);
  protected readonly router = inject(Router);

  linkDestination = computed(() => this.userStateService.isLoggedIn() ? '/home' : '/');

  login() {
    this.router.navigate(['/']);
  }

  logout() {
    this.userStateService.resetUserState();
    this.router.navigate(['/']);
  }
}
